import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getRulesetList = async (queries = '') => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/schedule-ruleset?${queries}` });

  return data?.data;
};

export default getRulesetList;
